import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles, Typography, Hidden } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreator from '../store/actions';
import backgroundImageLight from "../images/backgroundLight.png";
import backgroundImageDark from "../images/backgroundDark.png";
import { themeTypeToBool } from '../utils/helpers';
import t from "../languages/pl";
import ForgotPassword from "../components/AuthComponents/ForgotPassword";
import MobileAppBadges from './../components/AuthComponents/MobileAppBagde/MobileAppBadges';

const styles = theme => ({
  container: {
    width: "50%",
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: 'relative',
  },
  textField: {
    margin: theme.spacing(1),
    maxWidth: 450,
    [theme.breakpoints.up("md")]: {
      width: 450
    },
  },
  inputField: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 1000px ${theme.palette.background.default} inset`,
      WebkitTextFillColor: themeTypeToBool(theme.palette.type) ? "#000" : "#FFF",
    }
  },
  button: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),
    width: 200,
    color: "#FFF"
  },
  image: {
    width: "50%",
    backgroundImage: `url(${themeTypeToBool(theme.palette.type) ? backgroundImageLight : backgroundImageDark})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "right bottom"
  },
  header: {
    marginBottom: theme.spacing(5),
  },
  headerText: {
    textAlign: "center",
    margin: theme.spacing(3)
  },
  form: {
    display: "flex",
    flex: "wrap",
    flexDirection: "column",
    justifyContent: "center"
  },
  accountProps: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    margin: theme.spacing(1)
  },
  checkbox: {
    color: themeTypeToBool(theme.palette.type) ? "#808495" : "#FFF",
  },
  footer: {
    position: "absolute",
    bottom: 10
  },
  appBadges: {
    display: "flex",
    justifyContent: "flex-end",
    position: "absolute",
    bottom: 20,
    right: 0
  },
  section: {
    paddingBottom: theme.spacing(10)
  },
  userBlockedNotification: {
    color: "#FF6666",
    textAlign: "center",
    fontSize: '1rem'
  }
});

const AuthWrapper = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  margin: 0;
`;

class AuthView extends Component {

  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: ""
    };

    this.onTextFieldChangeHandler = this.onTextFieldChangeHandler.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onKeyUpHandler = this.onKeyUpHandler.bind(this);
    this.handleForgotPassword = this.handleForgotPassword.bind(this);
  }

  onTextFieldChangeHandler(e) {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  }

  onSubmit() {
    this.props.logIn(this.state.username, this.state.password);
  }

  onKeyUpHandler(e) {
    if (e.key === "Enter")
      this.onSubmit();
  }

  handleForgotPassword(username, email) {
    this.props.forgotPassword(username, email);
  }

  render() {
    const { classes, theme, error, isUserBlocked, isUserExpired } = this.props;
    const { username, password } = this.state;

    return (
      <AuthWrapper>
        <div className={classes.container}>
          <section className={classes.section}>
            <div className={classes.header}>
              <Typography
                variant="h3"
                className={classes.headerText}
              >
                QSAFE24 Flota
              </Typography>
              <Typography
                variant="subtitle2"
                className={classes.headerText}
              >
                {t.administratorPanel}
              </Typography>
            </div>

            {isUserBlocked &&
              <Typography
                variant="body2"
                className={classes.userBlockedNotification}
              >
                {t.userBlockedNotification}
              </Typography>
            }
            {isUserExpired &&
              <Typography
                variant="body2"
                className={classes.userBlockedNotification}
              >
                {t.userAccountExpiredNotification}
              </Typography>

            }
            <form className={classes.form} onKeyUp={this.onKeyUpHandler}>
              <TextField
                classes={{ root: classes.textField }}
                id="username"
                label={t.usernameLabel}
                type="text"
                name="username"
                value={username}
                color={themeTypeToBool(theme.palette.type) ? "secondary" : "primary"}
                InputProps={{
                  classes: { input: classes.inputField }
                }}
                InputLabelProps={{
                  style: { color: themeTypeToBool(theme.palette.type) ? "#32387D" : "inherit" }
                }}
                onChange={this.onTextFieldChangeHandler}
              />
              <TextField
                className={classes.textField}
                id="password"
                label={t.passwordLabel}
                type="password"
                name="password"
                error={error}
                value={password}
                color={themeTypeToBool(theme.palette.type) ? "secondary" : "primary"}
                InputLabelProps={{ style: { color: themeTypeToBool(theme.palette.type) ? "#32387D" : "inherit" } }}
                onChange={this.onTextFieldChangeHandler}
              />
              <div className={classes.accountProps}>
                <ForgotPassword
                  onForgotPassword={this.handleForgotPassword}/>
              </div>
              <Button
                className={classes.button}
                color={themeTypeToBool(theme.palette.type) ? "secondary" : "primary"}
                variant="contained"
                onClick={this.onSubmit}
              >
                {t.logInLabel}
              </Button>
            </form>
          </section>
          <div className={classes.appBadges}>
            <MobileAppBadges/>
          </div>
          <div className={classes.footer}>
            <Typography variant="body1">
              Copyrights © 2020: ETS Polska
            </Typography>
          </div>
        </div>
        <Hidden smDown>
          <div className={classes.image}/>
        </Hidden>
      </AuthWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.authReducer.authError,
    isUserBlocked: state.authReducer.isUserBlocked,
    isUserExpired: state.authReducer.isUserExpired
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActionCreator, dispatch);
};

AuthView.propTypes = {
  classes: PropTypes.object,
  theme: PropTypes.object,
  error: PropTypes.bool,
  isUserBlocked: PropTypes.bool,
  isUserExpired: PropTypes.bool,
  //redux
  logIn: PropTypes.func,
  forgotPassword: PropTypes.func
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(styles, { withTheme: true })
)(AuthView);
